import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'
import { normalizeError } from '../../utils/errorHelpers'

export const createCoApplicant = createAsyncThunk('coApplicants/create', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post('/co-applicants', data)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const getCoApplicantById = createAsyncThunk('coApplicants/getById', async (id, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/co-applicants/${id}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const updateCoApplicant = createAsyncThunk('coApplicants/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/co-applicants/${id}`, data)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const deleteCoApplicant = createAsyncThunk('coApplicants/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/co-applicants/${id}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const searchCoApplicants = createAsyncThunk('coApplicants/search', async ({ query, company }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/co-applicants/search?q=${encodeURIComponent(query)}&company=${company}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
